import { useLocation } from 'react-router-dom'

import history from 'services/HistoryService'

export const approvalQueuePath = '/approvals'

interface ReturnToLocationState {
  returnTo?: string
}

interface BackNavigation {
  path: string
  label: string
}

const returnToLabels: Record<string, string> = {
  [approvalQueuePath]: 'Back To Approvals'
}

export const pushWithReturnTo = (path: string, returnTo: string) => history.push(path, { returnTo })

export const useBackNavigation = (fallbackPath: string, fallbackLabel: string): BackNavigation => {
  const location = useLocation<ReturnToLocationState | undefined>()
  const returnTo = location.state?.returnTo

  if (returnTo && returnToLabels[returnTo]) {
    return { path: returnTo, label: returnToLabels[returnTo] }
  }

  return { path: fallbackPath, label: fallbackLabel }
}
